
interface User {
  id: number;
  date: string;
  name: string;
  address: string;
  address2: string;
  address3: string;
  hasChildren?: boolean;
  children?: User[];
}

import { defineComponent, onMounted } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";

export default defineComponent({
  name: "widgets-tables",
  components: {},
  setup() {
    const load = (
      row: User,
      treeNode: unknown,
      resolve: (date: User[]) => void
    ) => {
      setTimeout(() => {
        resolve([
          {
            id: 1,
            date: "2016-05-01",
            name: "wangxiaohu",
            address: "No. 189, Grove St, Los Angeles",
            address2: "No. 189, Grove St, Los Angeles",
            address3: "Nngeles",
          },
          {
            id: 2,
            date: "2016-05-01",
            name: "wangxiaohu",
            address: "No. 189, Grove St, Los Angeles",
            address2: "No. 189, Grove St, Los Angeles",
            address3: "Nngeles",
          },
          {
            id: 3,
            date: "2016-05-01",
            name: "wangxiaohu",
            address: "No. 189, Grove St, Los Angeles",
            address2: "No. 189, Grove St, Los Angeles",
            address3: "Nngeles",
          },
        ]);
      }, 1000);
    };
    const tableData: User[] = [
      {
        id: 3,
        date: "1421",
        name: "DBA Name",
        address: "Phone",
        address2: "Mid Number",
        address3: "???",
        children: [
          {
            id: 1,
            date: "",
            name: "Website",
            address: "Address",
            address2: "Email",
            address3: "Nngeles",
          },
          {
            id: 2,
            date: "Totals",
            name: "Chargebacks",
            address: "Alerts",
            address2: "???",
            address3: "???",
          },
        ],
      },
    ];

    onMounted(() => {
      setCurrentPageBreadcrumbs("Tables", ["Widgets"]);
    });
    return { load, tableData };
  },
});
